<div class="zas-width container-fluid">
    <h1>
        Beratungsdokumentation
        <span class="header-version">{{ buildVersion }}</span>
        <div *ngIf="!zbdGlobals.embedded" class="main-menu-container">
            <zbd-main-menu>
                <li *ngIf="isAdmin()">
                    <a [routerLink]="['admin']">
                        <span class="icon-link prefix-icon"></span
                        >&nbsp;Administration
                    </a>
                </li>
            </zbd-main-menu>
        </div>
    </h1>

    <ng-container *ngIf="state$ | async; let state; else: loading">
        <ng-container *ngIf="validity$ | async; let validity">
            <div [hidden]="consultationService?.loadError">
                <zbd-selector-strip
                    store-key="selectedMainSection"
                    [validity]="validity"
                >
                    <zbd-selector
                        *ngIf="!state.cp.IsFinished"
                        value="customer"
                        [validity]="validity.customer"
                        title="Kunde"
                        long-title="Kundendaten"
                    ></zbd-selector>
                    <zbd-selector
                        *ngIf="!state.cp.IsFinished"
                        value="agent"
                        [validity]="validity.agent"
                        title="Versicherungspartner"
                    ></zbd-selector>
                    <zbd-selector
                        *ngIf="!state.cp.IsFinished"
                        value="attendants"
                        [validity]="validity.attendants"
                        title="Teilnehmer und Termine"
                        long-title="Teilnehmer und Datum des Beratungsgesprächs"
                    ></zbd-selector>
                    <zbd-selector
                        *ngIf="!state.cp.IsFinished"
                        value="occasion"
                        [validity]="validity.occasion"
                        title="Beratungsanlass"
                        long-title="Kundenwunsch/Beratungsanlass"
                    ></zbd-selector>
                    <zbd-selector
                        *ngIf="!state.cp.IsFinished"
                        value="products"
                        [validity]="validity.productPicker"
                        title="Produkte"
                        long-title="Produktauswahl"
                    ></zbd-selector>
                    <zbd-selector
                        *ngIf="!state.cp.IsFinished"
                        [disabled]="pending$ | async"
                        value="analysis"
                        [validity]="validity.analysis"
                        title="Empfehlung und Entscheidung"
                        long-title="Kundenbedarf, Empfehlung und Entscheidung"
                    ></zbd-selector>
                    <zbd-selector
                        #pdfToggle
                        [validity]="validity.document"
                        [disabled]="pending$ | async"
                        [value]="dokumentenvorschau.key"
                        [title]="dokumentenvorschau.label"
                    ></zbd-selector>
                </zbd-selector-strip>
                <hr class="bold-underline" />

                <h4>{{ state.view.selectedMainSection?.label }}</h4>
                <br />
                <zbd-customer
                    #customer
                    *ngIf="state.view.selectedMainSection?.key === 'customer'"
                ></zbd-customer>
                <zbd-agent
                    #agent
                    *ngIf="state.view.selectedMainSection?.key === 'agent'"
                ></zbd-agent>
                <zbd-attendants
                    #attendants
                    *ngIf="state.view.selectedMainSection?.key === 'attendants'"
                ></zbd-attendants>
                <zbd-occasion
                    *ngIf="state.view.selectedMainSection?.key === 'occasion'"
                ></zbd-occasion>
                <zbd-product-picker
                    *ngIf="state.view.selectedMainSection?.key === 'products'"
                ></zbd-product-picker>
                <zbd-analysis
                    *ngIf="state.view.selectedMainSection?.key === 'analysis'"
                ></zbd-analysis>
                <div
                    *ngIf="state.view.selectedMainSection?.key === 'document'"
                    class="enlarged-content"
                >
                    <zbd-pdf-viewer
                        (requestReload)="onRequestDocumentReload(state.cp)"
                    ></zbd-pdf-viewer>
                </div>
            </div>

            <confirm-modal></confirm-modal>
            <prompt-modal></prompt-modal>
        </ng-container>
    </ng-container>

    <ng-template #loading>
        <div
            *ngIf="!(protocolLoadFailed$ | async); else loadFailed"
            class="waiting"
        >
            <span class="icon-loop spinning"></span>
            <span class="message">Vorgang wird geladen ...</span>
        </div>
    </ng-template>

    <ng-template #loadFailed>
        <div class="waiting">
            <span class="message">Vorgang konnte nicht geladen werden.</span>
        </div>
    </ng-template>
</div>
